import { createContext } from 'react';

export interface UserInfo {
  rxTied?: boolean;
  hasRxCId?: boolean;
  dontCollectProfile: boolean;
  userType?: string;
  lookupId?: string;
  lookupToken?: string;
  entryPoint?: string;
  caregiveeInfo?: CaregiveeInfo;
  caregiverInfo?: CaregiveeInfo;
  lookupStatusCode?: string;
  updated?: boolean;
  caregiveeType?: string;
  hasContact?: string;
  ssk?: string;
  remainingPotentialCaregivees?: number;
  source?: string;
}

export interface CaregiveeInfo {
  firstName?: string;
  lastName?: string;
  notificationType?: string;
  notificationValue?: string;
  sourceSystems?: string[];
  dob?: string;
}
export interface ContextInterface {
  user: UserInfo;
  updateUser: (value: any) => void;
}

const Context = createContext<ContextInterface | null>(null);

export default Context;
